/* global __CLIENT__ */

import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { DFPSlotsProvider } from 'react-dfp';
import ReactModal from 'react-modal';
import shouldUseGam from '../helpers/shouldUseGam';
import Root from './Root';
import { useOptionalCookies } from '../helpers/optionalCookies';

if (__CLIENT__) {
    // eslint-disable-next-line global-require
    require('../scss/bundle.scss');
    // swiper v12 is CSS-only (no SCSS). Imported here (entry point) so it always
    // lands in bundle.css regardless of build mode, avoiding a separate vendor chunk.
    // eslint-disable-next-line global-require
    require('swiper/css');
    // eslint-disable-next-line global-require
    require('swiper/css/navigation');
    // eslint-disable-next-line global-require
    require('swiper/css/scrollbar');
    // eslint-disable-next-line global-require
    require('swiper/css/effect-coverflow');
    // eslint-disable-next-line global-require
    require('swiper/css/pagination');
    // FontAwesome SVG Core: sizing/display rules for svg-inline--fa.
    // Must be imported via JS (not SCSS) so webpack inlines it; see webpack.common.js.
    // eslint-disable-next-line global-require
    require('@fortawesome/fontawesome-svg-core/styles.css');
}

const render = (Component) => {
    const Application = () => {
        const consent = useOptionalCookies();

        return (
            <DFPSlotsProvider
                dfpNetworkId="198073784,60229764/antena_1"
                autoLoad={shouldUseGam() && consent}
                collapseEmptyDivs
                lazyLoad
            >
                <Component />
            </DFPSlotsProvider>
        );
    };

    hydrateRoot(document.getElementById('Main'), <Application />);
};

ReactModal.setAppElement('#Main');

render(Root);

if (import.meta.webpackHot) {
    import.meta.webpackHot.accept('./Root', () => { render(Root); });
}
